import MixDesignViewStore from "./MixDesignViewStore";

const mixDesignStoreList = [
  { name: "mixDesignViewStore", store: MixDesignViewStore },
];

export default mixDesignStoreList;